import { combine } from 'effector';
import { errorType$ } from 'model/error.model';
import { countryCode$ } from 'model/main.model';
import { sessionConfig$ } from 'model/session.model';
import { localization$ } from 'model/localization.model';

export const isReady$ = combine(
	localization$, sessionConfig$, errorType$, countryCode$, countryCode$,
	(localization, session, errorType, countryCode) => {
		return (!!localization && !!session && !!countryCode) || (!!localization && !!errorType && !!countryCode);
	},
);
export const readyStatus$ = combine(
	localization$, sessionConfig$, errorType$, countryCode$, countryCode$,
	(localization, session, errorType, countryCode) => {
		return {
			localization: !!localization,
			session: !!session,
			countryCode: !!countryCode,
			error: !!errorType,
		};
	},
)
